import React from "react";
import { ConfigFormView } from "../../../../common/ConfigForm/ConfigFormView";
import { BASIC_INFO_SECTIONS } from "../basicInfo.config";
import { BasicInfoStatusHeader } from "./BasicInfoStatusHeader";
import { hydrateBasicInfoForm } from "../basicInfo.payload";
import { EDIT } from "../../../../../constants";
import formStyle from "../../../../common/ConfigForm/ConfigForm.module.scss";
import styles from "../BasicInfo.module.scss";

export const BasicInfoViewMode = ({ customerData, header, extra, onEdit }) => {
  const data = hydrateBasicInfoForm(customerData);

  return (
    <div className={formStyle.form_container}>
      <div className={styles.view_top}>
        <BasicInfoStatusHeader editable={false} customerData={customerData} header={header} />
        <button type="button" className={formStyle.form_edit_btn} onClick={onEdit}>
          <i className="fa fa-pencil" aria-hidden="true"></i>
          {EDIT}
        </button>
      </div>

      <div className={styles.columns}>
        <div className={styles.column}>
          <ConfigFormView sections={BASIC_INFO_SECTIONS} column="left" extra={extra} data={data} />
        </div>
        <div className={styles.column}>
          <ConfigFormView sections={BASIC_INFO_SECTIONS} column="right" extra={extra} data={data} />
        </div>
      </div>
    </div>
  );
};
